"use client";
import React from "react";
import "./Flexiti.scss";
import Link from "next/link";
import { ReactSVG } from "react-svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useMediaQuery,
} from "@mui/material";
import { useRouter } from "next/navigation";

const Flexiti = () => {
  const isMobile = useMediaQuery("(max-width:1023px)");
  const router = useRouter();

  return (
    <div className="flexiti-page-wrapper">
      <div className="flexiti-header-wrapper baseContainer">
        <div className="breadcrumbs-wrapper">
          <Link href={"/"} className="text-xsmall-18 grey-100 weight-600">
            Home
          </Link>
          <ReactSVG src="/assets/next-arrow-small-ic.svg" />
          <p className="text-xsmall-18 white weight-700">
            FLEXITI FINANCIAL SERVICES
          </p>
        </div>

        <p className="section-main-header large white">
          Flexiti Financial Services
        </p>

        <img
          src={
            isMobile
              ? "/assets/Flexiti/flexiti-cover-mobile.svg"
              : "/assets/Flexiti/flexiti-cover.svg"
          }
          alt="Flexiti Financies"
        />
      </div>

      <div className="cards-wrapper baseContainer">
        <div className="maxWidth">
          <div className="cards-group">
            <div className="card">
              <img src="/assets/Flexiti/flexiti-logo.svg" />
              <div className="text-wrapper">
                <p className="text-medium-28 black weight-600">Who Is Flexiti?</p>
                <p className="text-medium-24 grey-600 weight-500">
                  Flexiti is a Canadian company that provides flexible payment
                  plans with low interest rates.
                </p>
              </div>
            </div>

            <div className="card">
              <img src="/assets/Flexiti/dollar-ic.svg" />
              <div className="text-wrapper">
                <p className="text-medium-28 black weight-600">Why Finance</p>
                <p className="text-medium-24 grey-600 weight-500">
                  Break up a large purchase into small affordable monthly
                  payments.
                </p>
              </div>

              <div className="bottom-wrapper">
                <ReactSVG src="/assets/Flexiti/money-ic.svg" />
                <p className="text-16 weight-500 black">
                  Purchase big-ticket items sooner and pay less interest than a
                  traditional credit card.
                </p>
              </div>
            </div>

            <div className="card">
              <img src="/assets/Flexiti/time-ic.svg" />
              <div className="text-wrapper">
                <p className="text-medium-28 black weight-600">How It Works</p>
                <p className="text-medium-24 grey-600 weight-500">
                  Choose Flexiti at checkout, apply quickly, and get financing
                  approval in under 3 minutes.
                </p>
              </div>

              <div className="bottom-wrapper">
                <ReactSVG src="/assets/Flexiti/money-ic.svg" />
                <p className="text-16 weight-500 black">
                  Pay with equal monthly payments and{" "}
                  <span className="text-16 weight-700 black">0% interest</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-wrapper baseContainer ">
        <div className="cardSection maxWidth w-full">
          <div className="left">
            <img src={"/assets/Flexiti/flexiti-card.svg"} alt="Amherst Supply" />
          </div>

          <div className="right">
            <p className="section-main-header black">Why Choose Flexiti? </p>

            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                Flexible monthly payment plans that fit your budget{" "}
              </p>
            </div>
            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                On-the-spot financing{" "}
              </p>
            </div>
            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                High approval rates{" "}
              </p>
            </div>
            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                Convenient application process{" "}
              </p>
            </div>
            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                Easy and simple
              </p>
            </div>
            <div className="desc-wrapper">
              <ReactSVG src="/assets/Flexiti/check-circle.svg" />
              <p className="text-medium-24 weight-600 grey-600">
                Customer support, 7 days a week
              </p>
            </div>

            <button
              className="main-btn blue"
              onClick={() => {
                window.open(
                  "https://castle.ca/flexiti/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              Apply Now
            </button>
          </div>
        </div>


        <div className="flexiti-faqs maxWidth w-full">
          <div className="section_wrap maxWidth">
            <div className="text_box">
              <p className="section-main-header black weight-600">FAQs</p>
            </div>
            <div className="faq">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ReactSVG src="/assets/faq-arrow.svg" />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  How do I pay with Flexiti?
                </AccordionSummary>
                <AccordionDetails>
                  During checkout, you can select Flexiti Financing as your
                  payment method. When you select 'Apply Now', you will be
                  re-directed to Flexiti's application page where you will be able
                  to apply for credit or log into your existing Flexiti account.
                  Follow the on-screen prompts to complete the application and
                  receive an approval decision in under 3 minutes!
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ReactSVG src="/assets/faq-arrow.svg" />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Can I make multiple purchases through Flexiti?{" "}
                </AccordionSummary>
                <AccordionDetails>
                  Yes! Upon account approval, you will be given a virtual credit
                  card that you can use again and again to make purchases within
                  your approved credit limit.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ReactSVG src="/assets/faq-arrow.svg" />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  Why should I finance my Purchase?{" "}
                </AccordionSummary>
                <AccordionDetails>
                  Financing lets you purchase big-ticket items sooner by breaking
                  up your payments into smaller, affordable monthly payments - all
                  while paying less than a traditional credit card. With Flexiti,
                  the application is quick and simple, making it more convenient
                  than ever to finance your purchase.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ReactSVG src="/assets/faq-arrow.svg" />}
                  aria-controls="panel9-content"
                  id="panel9-header"
                >
                  How do I reach customer suport?{" "}
                </AccordionSummary>
                <AccordionDetails>
                  Reach fast, friendly, and reliable customer service when you
                  need it by calling 1-877-259-3745 on Monday to Friday from 9 am
                  to 11 pm ET or on Saturday and Sunday from 9 am to 9 pm ET.
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="flexiti-section maxWidth w-full">
          <div className="section_wrap p-[24px] maxWidth">
            <div className="left">
              <p className="section-main-header black">
                ZERO% Financing Available
              </p>
              <p className="text-medium-24 grey-700 weight-500">
                We've teamed up with Flexiti to help you instantly finance your
                purchases over $500 with 0% interest.
              </p>

              <button
                className="main-btn white-pink"
                onClick={() => {
                  window.open(
                    "https://flexiti.com/",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Learn More
              </button>
            </div>

            <div className="right">
              <img
                src={"/assets/Home/OurServices/flexiti.svg"}
                alt="amherst supply"
              />
            </div>
          </div>
        </div>

        <div className="text-statements-wrapper maxWidth w-full">
          <div className="maxWidth flex lg:flex-row flex-col gap-[24px]">
            <div className="bottom-wrapper">
              <ReactSVG src="/assets/Flexiti/notebook-ic.svg" />
              <p className="text-16 weight-500 black">
                O.A.C. Subject to terms of your Flexiti cardholder agreement. No
                interest will accrue during the promo period. Monthly payments
                include premiums for balance protection insurance, if applicable. If
                any payment is missed, the promo offer may be cancelled and upon
                cancellation, interest will be calculated at the cardholder
                agreement annual interest rate (AIR). Initial AIR is disclosed upon
                approval, varies based on cardholder's creditworthiness at time of
                application. Any balance at end of promotional term bears interest
                at the AIR.
              </p>
            </div>

            <div className="bottom-wrapper">
              <ReactSVG src="/assets/Flexiti/notebook-ic.svg" />
              <p className="text-16 weight-500 black">
                On approved credit. Admin fee may apply. Promotional plans and
                available interest rates vary by merchant partner and             applicant's
                credit rating.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flexiti;
